import { z } from 'zod/v4';
import { createDefinitionSchema } from '../utils/helpers';
import { SeriesNameType } from './shared';

export type LogsQueryReducer = z.infer<typeof logsReducerSchema>;

export enum LogsReducerTypes {
  First = 'First',
  Last = 'Last',
  Avg = 'Avg',
  Sum = 'Sum',
  Min = 'Min',
  Max = 'Max',
}

const logsReducerSchema = z.enum([
  LogsReducerTypes.First,
  LogsReducerTypes.Last,
  LogsReducerTypes.Avg,
  LogsReducerTypes.Sum,
  LogsReducerTypes.Min,
  LogsReducerTypes.Max,
]);

export const loggingQueryDefinitionSchema = createDefinitionSchema(
  'LogsDataQuery',
  z.object({
    query: z.string(),
    series_name: z
      .discriminatedUnion('type', [
        z.object({
          type: z.literal(SeriesNameType.Labels),
          name_pattern: z.string().optional(),
        }),
        z.object({
          type: z.literal(SeriesNameType.Regex),
          regex: z.string().optional(),
          name_pattern: z.string().optional(),
        }),
      ])
      .optional(),
    reducer: logsReducerSchema.optional(),
  })
);

export type LoggingQueryDefinition = z.infer<typeof loggingQueryDefinitionSchema>;
export type LoggingQuerySpec = LoggingQueryDefinition['spec'];

export type LogsFieldValuesVariableOptions = z.infer<typeof logsFieldValuesVariableSchema>;
const logsFieldValuesVariableSchema = z.object({
  field: z.string(),
});

export const logsFieldValuesVariableDefinitionSchema = createDefinitionSchema(
  'LogsFieldValuesVariable',
  logsFieldValuesVariableSchema
);
